import EditorOverlayStateEnum from '../EditorOverlayConstants';

export const SET_EDITOR_MODE = 'SET_EDITOR_MODE';
export const SET_EDITOR_MODE_ERROR = 'SET_EDITOR_MODE_ERROR';
export const ENABLE_EDIT = 'ENABLE_EDIT';
export const ENABLE_SIGN = 'ENABLE_SIGN';
export const ENABLE_VIEW = 'ENABLE_VIEW';
export const ENABLE_REQUEST_SIGNATURE = 'ENABLE_REQUEST_SIGNATURE';
export const ENABLE_REQUEST_SIGNATURE_WAIT = 'ENABLE_REQUEST_SIGNATURE_WAIT';
export const ENABLE_REQUEST_SIGNATURE_FILL = 'ENABLE_REQUEST_SIGNATURE_FILL';
export const ENABLE_SENDER_SIGNING = 'ENABLE_SENDER_SIGNING';
export const REQUEST_FREEWRITE_EXPORT = 'REQUEST_FREEWRITE_EXPORT';

export const ACTION_MODE_MAP = {
  ENABLE_EDIT: EditorOverlayStateEnum.EDIT,
  ENABLE_VIEW: EditorOverlayStateEnum.VIEW,
  ENABLE_SIGN: EditorOverlayStateEnum.SIGN,
  ENABLE_REQUEST_SIGNATURE: EditorOverlayStateEnum.REQUEST_SIGNATURE,
  ENABLE_REQUEST_SIGNATURE_WAIT: EditorOverlayStateEnum.REQUEST_SIGNATURE_WAIT,
  ENABLE_REQUEST_SIGNATURE_FILL: EditorOverlayStateEnum.REQUEST_SIGNATURE_FILL,
  ENABLE_SENDER_SIGNING: EditorOverlayStateEnum.SENDER_SIGNING,
};




// WEBPACK FOOTER //
// ./src-react/EditorOverlay/EditorOverlayActions/ActionTypes.jsx